import { useTranslation } from 'react-i18next';
import { Field } from 'app/components/core/Form';
import { Textarea } from 'app/components/core/Textarea';

export function JobDescriptionField({ name = 'description' }) {
    const { t } = useTranslation();

    return (
        <Field
            component={Textarea}
            name={name}
            maxChars={400}
            label={t('common:description', { context: 'optional' })}
            placeholder={t('jobs:definitions.description_placeholder')}
        />
    );
}
